import { lazy } from 'react'
import { CampaignUmbrellaListRBAC } from '../pages/CampaignUmbrella/List/rbac'
import { CampaignUmbrellaAddEditRBAC } from '../pages/CampaignUmbrella/AddEdit/rbac'
import { CampaignUmbrellaDetailRBAC } from '../pages/CampaignUmbrella/Detail/rbac'
import { CampaignUmbrellaChildRBAC } from '../pages/CampaignUmbrella/Child/rbac'

const CampaignUmbrellaList = lazy(() => import('../pages/CampaignUmbrella/List'))
const CampaignUmbrellaAddEdit = lazy(() => import('../pages/CampaignUmbrella/AddEdit'))
const CampaignUmbrellaDetail = lazy(() => import('../pages/CampaignUmbrella/Detail'))
const CampaignUmbrellaChild = lazy(() => import('../pages/CampaignUmbrella/Child'))

export const CampaignUmbrellaListRouter: RouterFeatureInterface<
  'CampaignUmbrellaListRouter',
  '/dashboard/campaign-umbrella'
> = {
  name: 'CampaignUmbrellaListRouter',
  Component: CampaignUmbrellaList,
  path: '/dashboard/campaign-umbrella',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CampaignUmbrellaListRBAC.pageID,
  isDashboard: true,
}

export const CampaignUmbrellaAddEditRouter: RouterFeatureInterface<
  'CampaignUmbrellaAddEditRouter',
  '/dashboard/campaign-umbrella-add-edit/:prefix/:id'
> = {
  name: 'CampaignUmbrellaAddEditRouter',
  Component: CampaignUmbrellaAddEdit,
  path: '/dashboard/campaign-umbrella-add-edit/:prefix/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CampaignUmbrellaAddEditRBAC.pageID,
  isDashboard: true,
}

export const CampaignUmbrellaDetailRouter: RouterFeatureInterface<
  'CampaignUmbrellaDetailRouter',
  '/dashboard/campaign-umbrella/detail/:id'
> = {
  name: 'CampaignUmbrellaDetailRouter',
  Component: CampaignUmbrellaDetail,
  path: '/dashboard/campaign-umbrella/detail/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CampaignUmbrellaDetailRBAC.pageID,
  isDashboard: true,
}

export const CampaignUmbrellaChildRouter: RouterFeatureInterface<
  'CampaignUmbrellaChildRouter',
  '/dashboard/campaign-umbrella/child/:prefix/:id'
> = {
  name: 'CampaignUmbrellaChildRouter',
  Component: CampaignUmbrellaChild,
  path: '/dashboard/campaign-umbrella/child/:prefix/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CampaignUmbrellaChildRBAC.pageID,
  isDashboard: true,
}

export const composeCampaignUmbrellaChildPath = (prefix: 'add' | 'edit', id: string) =>
  CampaignUmbrellaChildRouter.path.replace(':prefix', prefix).replace(':id', id)

export const composeCampaignUmbrellaAddEditPath = (prefix: 'add' | 'edit', id: string) =>
  CampaignUmbrellaAddEditRouter.path.replace(':prefix', prefix).replace(':id', id)
